import jQuery from "jquery";

window.Helpers = {};

// Removes any Dropdowns + preceding button if the dropdown contains nothing useful
jQuery.fn.removeEmptyDropdowns = function () {
  $(this)
    .find(".dropdown-toggle")
    .each(function () {
      const $button = $(this);
      const $dropdown = $button.next(".dropdown-menu");
      if ($dropdown.children(":not(.divider)").length == 0) {
        $button.remove();
        $dropdown.remove();
      }
    });
  return $(this);
};

// Removes li.dividers if they appear as first- or last-child in dropdown
jQuery.fn.removeOrphanedDropdownDividers = function () {
  $(this)
    .find(
      ".dropdown-menu > li.divider:first-child, .dropdown-menu > li.divider:last-child",
    )
    .remove();
  return $(this);
};

Helpers.isValidEmail = function (email) {
  return /.+@.+\..+/.test(email);
};

var chunkRgx = /(_+)|([0-9]+)|([^0-9_]+)/g;

Helpers.naturalSort = function (a, b) {
  if (!a || !b) {
    return -1;
  }
  var ax = [],
    bx = [];
  a.replace(chunkRgx, function (_, $1, $2, $3) {
    ax.push([$1 || "0", $2 || Infinity, $3 || ""]);
  });
  b.replace(chunkRgx, function (_, $1, $2, $3) {
    bx.push([$1 || "0", $2 || Infinity, $3 || ""]);
  });

  while (ax.length && bx.length) {
    var an = ax.shift();
    var bn = bx.shift();
    var nn =
      an[0].localeCompare(bn[0]) || an[1] - bn[1] || an[2].localeCompare(bn[2]);
    if (nn) return nn;
  }

  return ax.length - bx.length;
};

Helpers.naturalSortByObjectKey = function (key) {
  return function (a, b) {
    return Helpers.naturalSort(a[key], b[key]);
  };
};

Helpers.naturalSortByBackboneModelAttribute = function (key) {
  return function (a, b) {
    return Helpers.naturalSort(a.get(key), b.get(key));
  };
};
